/**
 * Aura blobs exported from Figma. Paths extend past the 353x107 artwork on purpose - only the part inside is
 * visible. `center` is the scale origin, in artwork units.
 *
 *   reach        growth at full level, as a share of the blob's size
 *   glow         opacity added at full level, on top of REST_OPACITY
 *   phaseOffset  position on the shared orbit, in cycles (0..1)
 */
// useAiAssistantAura finds the blobs by this class, in array order
export const AURA_BLOB_CLASS = 'ai-assistant-aura__blob';
export const AURA_WIDTH = 353;
export const AURA_HEIGHT = 107;
// Each blob's SVG box. Must fit the whole path: iOS Safari crops a blob to its box before blurring
export const AURA_CANVAS = {x: -60, y: 10, width: 500, height: 150};

const aiAssistantAuraBlobs = [
    {
        d: 'M412.253 38.5844C394.04 13.6847 387.33 79.7547 321.812 97.699C256.294 115.643 178.293 108.4 185.361 118.063C192.429 127.726 293.939 146.182 330.838 136.076C367.738 125.969 430.466 63.484 412.253 38.5844Z',
        fill: '#00D1D2',
        center: {x: 300.21, y: 86.03},
        reach: 0.5,
        glow: 0.45,
        phaseOffset: 0,
    },
    {
        d: 'M275.977 101.385C239.14 105.685 231.338 132.06 232.042 138.299L379.477 134.996L333.43 78.9778C329.628 84.6551 312.815 97.0849 275.977 101.385Z',
        fill: '#0043D2',
        center: {x: 305.74, y: 108.64},
        reach: 0.4,
        glow: 0.5,
        phaseOffset: 0.17,
    },
    {
        d: 'M71.5463 117.385C108.384 121.685 116.185 148.06 115.481 154.299L-31.954 150.996L14.093 94.9778C17.8951 100.655 34.7086 113.085 71.5463 117.385Z',
        fill: '#0043D2',
        center: {x: 41.78, y: 124.64},
        reach: 0.4,
        glow: 0.5,
        phaseOffset: 0.58,
    },
    {
        d: 'M242.306 125.666C302.178 127.333 314.857 137.559 313.712 139.978L74.0899 138.698L148.929 116.978C155.108 119.18 182.435 123.999 242.306 125.666Z',
        fill: '#00D1D2',
        center: {x: 193.94, y: 128.48},
        reach: 0.55,
        glow: 0.45,
        phaseOffset: 0.33,
    },
    {
        d: 'M165.553 130.061C174.389 117.359 118.608 126.371 58.457 110.703C-1.69424 95.0351 -48.845 68.3932 -52.2741 73.3226C-55.7032 78.2519 -19.5112 109.023 40.6401 124.691C100.791 140.359 156.717 142.764 165.553 130.061Z',
        fill: '#533377',
        center: {x: 56.99, y: 105.47},
        reach: 0.2,
        glow: 0.3,
        phaseOffset: 0.71,
    },
    {
        d: 'M284.168 108.173C283.56 100.259 243.847 113.845 185.49 115.524C127.132 117.203 72.6008 111.181 72.8368 114.252C73.0727 117.323 121.246 127.219 179.603 125.54C237.96 123.862 284.776 116.086 284.168 108.173Z',
        fill: '#533377',
        center: {x: 178.5, y: 115.72},
        reach: 0.25,
        glow: 0.3,
        phaseOffset: 0.09,
    },
];

export default aiAssistantAuraBlobs;
